import React, { useEffect, useState } from "react";
import { FaChevronUp } from "react-icons/fa";
import "./css/ScrollTopButton.scss";

const SHOW_AFTER_PX = 320;

function ScrollTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      setVisible(y > SHOW_AFTER_PX);
    };

    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    const prefersReduced =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    window.scrollTo({
      top: 0,
      behavior: prefersReduced ? "auto" : "smooth",
    });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      className="scroll-top-button"
      onClick={scrollToTop}
      aria-label="페이지 맨 위로"
      title="맨 위로"
    >
      <FaChevronUp size={16} aria-hidden />
    </button>
  );
}

export default ScrollTopButton;
